import { useState, useEffect} from 'react'

export function useIsMobile(){
    //const [ userMobile, setUserMobile ] = useState()
    const [ isMobile, setIsMobile ] = useState()
    
    //Valida si es desktop o mobile
    useEffect(()=>{
        if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            //setUserMobile('desktop')
            setIsMobile('desktop')
        }
        else{
            //setUserMobile('movil')
            setIsMobile('movil')
        }
    },[])


    // useEffect(()=>{
    //     if(userMobile){
    //         setIsMobile(userMobile)
    //     }
    // },[userMobile])
    
    return{isMobile}
}